import { Component, Input } from '@angular/core';
import { PermissionHandler } from '../../../service/PermissionHandler';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../service/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ch-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent extends PermissionHandler {

  @Input()
  height: number = 61;

  constructor(private readonly modalService: BsModalService,
              private readonly router: Router,
              private readonly authenticationService: AuthenticationService) {
    super(JSON.parse(localStorage.getItem('currentUser')).permissions);
  }

  logout() {
    this.authenticationService.logout().subscribe(() => {
      localStorage.removeItem('currentUser');
      this.modalService.hide(1);
      this.router.navigateByUrl('/login');
    });
  }
}
